import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "../motion/Reveal";
import { LESSONS, IMAGES } from "../../data/content";

// Heading + FULL uncropped, vivid image
const LessonsIntro = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);
  return (
    <div className="container-editorial pt-20 md:pt-28">
      <Reveal>
        <p className="overline mb-4">05 — Lessons</p>
        <h2 className="font-serif text-4xl md:text-7xl leading-[1] tracking-tight text-bone max-w-4xl">
          Lessons From <span className="italic text-gold">Markets</span> and Life.
        </h2>
      </Reveal>
      <Reveal y={50} delay={0.1}>
        <motion.div
          ref={ref}
          style={{ y }}
          className="relative mt-12 md:mt-16 overflow-hidden border border-white/10 bg-ink"
        >
          <img
            src={IMAGES.lessonsPortrait}
            alt="Dakka Gabriel Rey"
            className="w-full h-auto object-cover contrast-[1.1] saturate-[0.95] brightness-[1.02] sepia-[0.1]"
            loading="lazy"
          />
          <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-ink/55 via-transparent to-ink/10" />
          <div className="pointer-events-none absolute inset-0 bg-gold/10 mix-blend-overlay" />
        </motion.div>
      </Reveal>
    </div>
  );
};

export const Lessons = () => {
  return (
    <section id="lessons" className="relative">
      <LessonsIntro />
      <div className="container-editorial py-16 md:py-24">
        <div className="divide-y divide-white/10">
          {LESSONS.map((l, i) => (
            <Reveal key={l.no} delay={i * 0.05}>
              <div
                data-testid={`lesson-${i}`}
                className="group grid grid-cols-12 gap-4 md:gap-8 py-8 md:py-10 items-baseline"
              >
                <div className="col-span-12 md:col-span-1">
                  <span className="font-serif text-5xl md:text-6xl text-white/10 group-hover:text-gold/60 transition-colors duration-500">
                    {l.no}
                  </span>
                </div>
                <div className="col-span-12 md:col-span-4">
                  <h3 className="font-serif text-2xl md:text-3xl text-bone tracking-tight">{l.title}</h3>
                </div>
                <div className="col-span-12 md:col-span-7">
                  <p className="text-lg text-ash leading-relaxed">{l.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
